import { Injectable } from '@angular/core';
import {
  StatefulService
} from '@core/services/stateful-service-management/stateful-service-interface/stateful-service-interface';
import { environment } from '@environments/environment';

export enum DigitalResourceIcon {
  Apple = 'Apple',
  Avocado = 'Avacado',
  Bacillus = 'Baccilus',
  Balloon = 'balloon',
  Beetle = 'Beetle',
  Camera = 'Camera',
  Carrot = 'Carrot',
  Chick = 'Chick',
  Clock = 'Clock',
  Computer = 'Computer',
  Confetti = 'Confetti',
  Corn = 'Corn',
  Crayon = 'Crayon',
  Die = 'Die',
  Dinosaur = 'Dinosaur',
  Dolphin = 'Dolphin',
  ErrorSymbol = 'Error',
  AmericanFootball = 'Football (American)',
  Gorilla = 'Gorilla',
  GradCap = 'Grad Cap',
  Hamburger = 'Hamburger',
  HammerAndWrench = 'Hammer + Wrench',
  Heart = 'heart',
  Hibiscus = 'Hibiscus',
  IceCreamCone = 'Ice Cream Cone',
  Lemon = 'Lemon',
  Lobster = 'Lobster',
  Lock = 'Lock',
  MegaPhone = 'Mega Phone',
  MoneyBag = 'Money Bag',
  PaintBrush = 'PaintBrush',
  Palette = 'Pallette',
  Pancakes = 'Pancakes',
  PaperClips = 'PaperClips',
  Pear = 'Pear',
  Penguin = 'Penguin',
  Pineapple = 'Pinapple',
  Pizza = 'Pizza',
  Planet = 'Planet',
  Pretzel = 'Pretzel',
  PushPin = 'Push Pin',
  Raccoon = 'Raccoon',
  RocketShip = 'Rocketship',
  Scissors = 'Scissors',
  Stars = 'Stars',
  StopSign = 'Stop Sign',
  Taco = 'Taco',
  Thermometer = 'Thermometer',
  Tiger = 'Tiger',
  Trophy = 'Trophy',
  Turtle = 'Turtle'
}

/** Contains State */
@Injectable({
  providedIn: 'root'
})
export class DigitalResourceIconService implements StatefulService {

  contentPath: string = '';

  getUriFromIconName(iconName: DigitalResourceIcon) {
    return this.getUriFromIconPath(`${this.contentPath}${iconName}.svg`);
  }

  getUriFromIconPath(iconPath: string): string {
    return `${environment.assetUrl}${iconPath}`;
  }

  /** Resets the stateful properties of this service. */
  reset(): void {
    this.contentPath = '';
  }

}
